import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/utils/rem";
import "vant/lib/index.css";
import Vant from "vant";
import Vconsole from "vconsole";
import VueVideoPlayer from '@videojs-player/vue'
import './permission'
import 'video.js/dist/video-js.css'
if (process.env.NODE_ENV === "development") {
  new Vconsole();
}
createApp(App).use(store).use(Vant).use(VueVideoPlayer).use(router).mount("#app");
